const payment = () => import ('@/pages/bill-payment/payment')
const detail = () => import ('@/pages/bill-payment/detail')
export default [
    {
        path: 'bill-payment/payment',
        name:'bill-payment/payment',
        component: payment
    },
    {
        path: 'bill-payment/payment/detail/:way/:gldId/:fromType',
        name:'bill-payment/payment/detail',
        component: detail,
        meta:{
          // 设置此meta可打开一个tab页，不设置的话默认打开父级导航的菜单页
          title:"祺信详情",
          notMenu:true
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/bill-payment.js